import React from 'react';
import { NavigationLinkWithIcon, ButtonWithBigIcon } from './TopNavStyles';
import { getHelpText } from './TopNavHelpers';

const hasHelp = () => !!getHelpText();

const helpProps = () => {
  const props = {
    id: 'btn-help',
    title: 'Help',
  };
  if (hasHelp()) {
    props['data-action'] = 'Feedback';
    props['data-params'] = getHelpText();
  } else {
    props.onClick = () => ADV.Controller.Help();
  }
  return props;
};

export default () => (
  <NavigationLinkWithIcon>
    <ButtonWithBigIcon {...helpProps()} prependIcon="fa fa-question-circle" aria-label="help" />
  </NavigationLinkWithIcon>
);
